// extracted by mini-css-extract-plugin
export default {"root":"style_root__w-Zxy","container":"style_container__u3-jk","image":"style_image__hHbUf","data":"style_data__aqx1c"};